import React from 'react'
import PropTypes from 'prop-types'
import { TextField, useContainerWidth } from '@fs/zion-ui'
import styles from './SearchBox.styles'

export default function SearchBox({ Icon, onChange, onClear, placeholder = '', type = 'search', value = '' }) {
  const atWidth = useContainerWidth()
  const searchBoxProps = {
    Icon,
    onChange,
    onClear,
    placeholder,
    type,
    value,
  }
  return (
    <div css={atWidth(styles.searchCss())}>
      <TextField {...searchBoxProps} aria-label={placeholder} />
    </div>
  )
}

SearchBox.propTypes = {
  Icon: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
}
